export default "__VITE_PUBLIC_ASSET__9113eae1__"